// extracted by mini-css-extract-plugin
export default {"root":"TopicTagsSelect_root__PrSMk","control":"TopicTagsSelect_control__qOeqS","select":"TopicTagsSelect_select__aVhQy","button":"TopicTagsSelect_button__FOt2A"};